<template>
  <div class="flex flex-col">
    <label for="id" class="font-nutino font-bold text-[16px] text-[#535353] mb-2">{{ label }}</label>
    <input
      class="w-full border border-[#5d5d5d] bg-[#fff] rounded-[20px]  focus:ring-[#FFC107] focus:border-[#FFC107] py-[18px] px-[24px]"
      :class="[
          errors && errors.length > 0 ? 'border-red-400 ring-red-400': '',
          variant === 'dark' ? 'bg-[#fff] bg-opacity-5 text-white' : 'bg-white bg-opacity-none text-black',
        ]"
      :id="id"
      ref="inputElement"
      type="text"
      :placeholder="placeholder"
      v-model="model"
    />
    <span class="text-red-400 text-xs" v-if="errors" v-for="error in errors" v-text="error"></span>
  </div>
</template>

<script setup lang="ts">
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';
import { en, es, uk, ru } from "intl-tel-input/i18n";

type TVariant = 'dark' | 'light';

interface Props {
  label: string
  placeholder?: string
  errors?: string[]
  variant?: TVariant,
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'dark',
});

const id = useId();
const model = defineModel();

const {locale} = useI18n();
const currentInputLocales = computed(() => {
  if (locale.value === 'en') {
    return en;
  } else if (locale.value === 'uk') {
    return uk;
  } else if (locale.value === 'es') {
    return es;
  } else if (locale.value === 'ru') {
    return ru;
  }
})

const inputElement = ref();
const iti = ref();
onMounted(() => {
  iti.value = intlTelInput(inputElement.value, {
    loadUtils: () => import("intl-tel-input/utils"),
    initialCountry: 'ua',
    separateDialCode: true,
    strictMode: true,
    nationalMode: true,
    i18n: currentInputLocales.value,
  });
})

defineExpose({
  getFullNumber: () => {
    return iti.value?.getNumber(0).replaceAll(' ', '');
  },
  getCountryCode: () => {
    return iti.value?.getSelectedCountryData().iso2;
  },
})
</script>

<style>
.iti__dropdown-content {

}

.iti__selected-dial-code {
  color: #fff;
}
</style>